import "./Poster.css";

export default function Poster({ movie }) {
  return (
    <div className="poster-group-block">
      <div>
        <img
          src={`https://image.tmdb.org/t/p/w1280/${movie.poster_path}`}
          width={"440px"}
          alt="poster"
          className="poster-img-block"
        />
        <div className="poster-text-block">
          <p className="poster-span-text">{movie.tagline}</p>
        </div>
      </div>
    </div>
  );
}
